import {
  createReducer,
  createRequestReducer
} from 'utils';

import { GET_INVESTORS_FILES } from './constants';

const initialState = {
  files: {
    bonds: {
      title: '',
      items: []
    },
    general: {
      title: '',
      items: []
    },
    message: {
      title: '',
      items: []
    }
  },
  isFetching: false,
  fetchingErrors: null
};

export default createReducer(initialState, {
  [GET_INVESTORS_FILES]: (state, action) => {
    return createRequestReducer(state, action, {
      SEND: (state) => {
        return Object.assign(state, {
          isFetching: true,
          fetchingErrors: null
        });
      },

      SUCCESS: (state, action) => {
        const { response } = action.request;
        return Object.assign(state, {
          files: response.files,
          isFetching: false,
          fetchingErrors: null
        });
      },

      FAIL: (state, action) =>
        Object.assign(state, {
          isFetching: true,
          fetchingErrors: action.request.error
        })
    });
  }
});



// WEBPACK FOOTER //
// ./src/redux/InvestorSection/reducer.js